import React from 'react';
import PropTypes from 'prop-types';

import { Container } from 'semantic-ui-react';

import ModalTypes from '../constants/ModalTypes';
import FixedContainer from '../containers/FixedContainer';
import StaticContainer from '../containers/StaticContainer';
import UsersModalContainer from '../containers/UsersModalContainer';
import UserSettingsModalContainer from '../containers/UserSettingsModalContainer';
import FactoryAddModalContainer from '../containers/FactoryAddModalContainer';
import BrandAddModalContainer from '../containers/BrandAddModalContainer';
import DeviceAddModalContainer from '../containers/DeviceAddModalContainer';
import AddDeviceToDiagramModalContainer from '../containers/AddDeviceToDiagramModalContainer';
import ModelAddModalContainer from '../containers/ModelAddModalContainer';
import ProtocolAddModalContainer from '../containers/ProtocolAddModalContainer';
import ChannelAddModalContainer from '../containers/ChannelAddModalContainer';
import ItemAddModalContainer from '../containers/ItemAddModalContainer';
import AlertSettingAddModalContainer from '../containers/AlertSettingAddModalContainer';
import SettingDashboardComponentContainer from '../containers/SettingDashboardComponentContainer';
import Background from './Background';
import SidebarContainer from '../containers/SidebarContainer';

const Core = ({ themeMode, menuDesktopActived, currentModal, currentFactory }) => (
  <div className={`theme-${themeMode}`}>
    <SidebarContainer />
    <div className={`content-wrapper ${menuDesktopActived ? 'sidebar-full' : 'sidebar-mini'}`}>
      {currentFactory && currentFactory.background && (
        <Background
          type={currentFactory.background.type}
          name={currentFactory.background.name}
          imageUrl={currentFactory.backgroundImage && currentFactory.backgroundImage.url}
        />
      )}
      <FixedContainer />
      <Container fluid>
        <StaticContainer />
      </Container>

      {currentModal === ModalTypes.USERS && <UsersModalContainer />}
      {currentModal === ModalTypes.USER_SETTINGS && <UserSettingsModalContainer />}
      {currentModal === ModalTypes.FACTORY_ADD && <FactoryAddModalContainer />}
      {currentModal === ModalTypes.BRAND_ADD && <BrandAddModalContainer />}
      {currentModal === ModalTypes.DEVICE_ADD && <DeviceAddModalContainer />}
      {currentModal === ModalTypes.ADD_DEVICE_TO_DIAGRAM && <AddDeviceToDiagramModalContainer />}
      {currentModal === ModalTypes.MODEL_ADD && <ModelAddModalContainer />}
      {currentModal === ModalTypes.PROTOCOL_ADD && <ProtocolAddModalContainer />}
      {currentModal === ModalTypes.CHANNEL_ADD && <ChannelAddModalContainer />}
      {currentModal === ModalTypes.ITEM_ADD && <ItemAddModalContainer />}
      {currentModal === ModalTypes.ALERT_SETTING_ADD && <AlertSettingAddModalContainer />}
      {currentModal === ModalTypes.ADD_COMPONENT_TO_DASHBOARD && (
        <SettingDashboardComponentContainer />
      )}
    </div>
  </div>
);

Core.propTypes = {
  themeMode: PropTypes.string,
  currentModal: PropTypes.oneOf(Object.values(ModalTypes)),
  currentFactory: PropTypes.objectOf(PropTypes.any),
  menuDesktopActived: PropTypes.bool,
};

Core.defaultProps = {
  themeMode: 'light',
  currentModal: undefined,
  currentFactory: undefined,
  menuDesktopActived: true,
};

export default Core;
